import React, {useEffect, useState} from "react";
import styles from "./TabContentServices.module.scss";
import "./index.scss";
import CardImage from "../Cards/CardImage";
import CardIcon from "../Cards/CardIcon";
import {Col, Row} from "react-bootstrap";
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

interface Content {
    title: string;
    text: string;
    image: string;
    link?: string;
    col?: number;
}

interface Icon {
    title: string;
    text: string;
    image: string;
    col?: number;
}

interface TabContentServicesProps {
    content: Content[];
    icons?: Icon[];
    title?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}

const ContentItem: React.FC<Content &
    { onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void; }>
    = (
    {
        title,
        text,
        image,
        link,
        onClick
    }) => (
    <CardImage
        title={title}
        text={text}
        image={image}
        link={link}
        className="CardImageWButton"
        onClick={onClick}
    />
);

const MobileContent: React.FC<{
    content: Content[]; onClick?:
        (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
}> = ({
          content,
          onClick
      }) => (
    <Swiper modules={[Autoplay, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{clickable: true}}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
    >
        {content.map((item, idx) => (
            <SwiperSlide key={idx}>
                <ContentItem {...item} onClick={onClick}/> {/* Передаем onClick */}
            </SwiperSlide>
        ))}
    </Swiper>
);

const DesktopContent: React.FC<{
    content: Content[]; onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
}> = ({
          content,
          onClick
      }) => (
    <Row className="g-4">
        {content.map((item, idx) => (
            <Col key={idx} md={6} xxl={item.col}>
                <ContentItem {...item} onClick={onClick}/> {/* Передаем onClick */}
            </Col>
        ))}
    </Row>
);

const TabContentServices: React.FC<TabContentServicesProps> = ({content, icons, title, onClick}) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.tabContent}>
            <div className={styles.tabContentTop}>
                {isMobile ? (
                    <MobileContent content={content} onClick={onClick}/>
                ) : (
                    content.length > 0 ? <DesktopContent content={content} onClick={onClick}/> :
                        <p>Нет доступного контента</p>
                )}
            </div>
            {icons && icons.length > 0 && (
                <div className={styles.tabContentBottom}>
                    <div className={styles.tabContentTitle}>Сервис «{title}» включает в себя</div>
                    <Row className="g-3 g-md-4">
                        {icons.map((icon, idx) => (
                            <Col key={idx} xs={12} md={6} lg={icon.col}>
                                <CardIcon title={icon.title} text={icon.text} image={icon.image}/>
                            </Col>
                        ))}
                    </Row>
                </div>
            )}
        </div>
    );
};


export default TabContentServices;
